const bootstrap = require('bootstrap');
window.bootstrap = bootstrap;
require('bootstrap-select');

export default function profileForm() {
    if($('.DashboardProfilePage').length > 0){
        const regionSelect = $('#ProfileForm_ProfileForm_Regions');
        const providerSelect = $('#ProfileForm_ProfileForm_AccTypes');
        const specialitySelect = $('#ProfileForm_ProfileForm_Specialities');
        regionSelect.selectpicker();
        providerSelect.selectpicker();
        specialitySelect.selectpicker();

        let pass = $('#ProfileForm_ProfileForm_Password');
        let confPass = $('#ProfileForm_ProfileForm_ConfirmPassword');
        let passButton = $('#password-update');
        passButton.css('cursor', 'pointer');
        let passRow = $('#password-row');

        passButton.on('click', function () {
            if (passRow.hasClass('d-none')) {
                passRow.removeClass('d-none');
                pass.prop('required', true);
                confPass.prop('required', true);
                passButton.html('Cancel');
            } else {
                passRow.addClass('d-none');
                pass.prop('required', false);
                confPass.prop('required', false);
                passButton.html('Update Password');
            }
        });


        $('form.needs-validation').each(function(i){
            $(this).on('submit', function(e){
                var formValid = $(this)[0].checkValidity();
                if (formValid) {
                    $(this).addClass('was-validated');
                }
                if (formValid === false) {
                    e.preventDefault();
                    $(this).addClass('was-validated');
                }
            });
        });

        $(document).ready(function () {
            let toolbarStyles = [
                ['font', ['bold', 'underline', 'italic']],
                ['para', ['ul','ol']],
                ['insert',['link']]
            ];

            let content = $('#ProfileForm_ProfileForm_Content');
            let contentPlaceholder = content.attr('placeholder');
            content.summernote({
                placeholder: contentPlaceholder,
                toolbar: toolbarStyles,
                height: 230,
                fontSize: 14,
                dialogsInBody: true
            });

            let qualifications = $('#ProfileForm_ProfileForm_Qualifications');
            let qualificationPlaceholder = qualifications.attr('placeholder');
            qualifications.summernote({
                placeholder: qualificationPlaceholder,
                toolbar: toolbarStyles,
                height: 230,
                fontSize: 14,
                dialogsInBody: true
            });

            let experience = $('#ProfileForm_ProfileForm_Experience');
            let experiencePlaceholder = experience.attr('placeholder');
            experience.summernote({
                placeholder: experiencePlaceholder,
                toolbar: toolbarStyles,
                height: 230,
                fontSize: 14,
                dialogsInBody: true
            });

            let privateContent = $('#ProfileForm_ProfileForm_PrivateContent');
            let privateContentPlaceholder = privateContent.attr('placeholder');
            privateContent.summernote({
                placeholder: privateContentPlaceholder,
                toolbar: toolbarStyles,
                height: 230,
                fontSize: 14,
                dialogsInBody: true
            });
        });

        const form = document.getElementById('ProfileForm_ProfileForm');
        let isFormChanged = false;

        // Set up event listeners for form fields to detect changes
        form.addEventListener('input', () => {
            isFormChanged = true;
        });

        form.addEventListener('change', () => {
            isFormChanged = true;
        });

        // Warn the user if they try to leave the page without saving changes
        window.addEventListener('beforeunload', function (event) {
            if (isFormChanged) {
                // Display a confirmation dialog
                const confirmationMessage = "You have unsaved changes. Are you sure you want to leave this page?";
                event.returnValue = confirmationMessage; // Legacy method for older browsers
                return confirmationMessage; // For modern browsers
            }
        });

        // Optional: Reset isFormChanged when the form is submitted
        form.addEventListener('submit', function () {
            isFormChanged = false;
        });
    }


}
